// extracted by mini-css-extract-plugin
module.exports = {"Archive":"ComponentBodyMagazineArchive_Archive__11Z5Y","Links":"ComponentBodyMagazineArchive_Links__cRg_Q"};